import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Inbox, GitBranch, Brain, FileText, Megaphone, Building2 } from 'lucide-react';
import { cn } from '../../utils/cn';
interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
interface NavGroup {
  label: string;
  items: NavItem[];
}
const groups: NavGroup[] = [{
  label: 'Pipeline',
  items: [{
    to: '/',
    label: 'Command dashboard',
    icon: LayoutDashboard
  }, {
    to: '/applications',
    label: 'Applications queue',
    icon: Inbox
  }]
}, {
  label: 'Lifecycle',
  items: [{
    to: '/lifecycle',
    label: 'Portfolio board',
    icon: GitBranch
  }]
}, {
  label: 'Intelligence',
  items: [{
    to: '/intelligence',
    label: 'AI intelligence hub',
    icon: Brain
  }, {
    to: '/reports',
    label: 'Reports archive',
    icon: FileText
  }]
}, {
  label: 'Delivery',
  items: [{
    to: '/outreach',
    label: 'Outreach & amplification',
    icon: Megaphone
  }]
}, {
  label: 'Administration',
  items: [{
    to: '/registry',
    label: 'Entities registry',
    icon: Building2
  }]
}];
export function SideNav() {
  return <nav aria-label="Platform sections" className="hidden w-60 shrink-0 border-r border-border bg-sidebar px-3 py-4 lg:block" data-id="element-473" data-mp="ermbpeim60ze">
      <div className="space-y-5" data-id="element-474" data-mp="5pcy2fs1trhs">
        {groups.map(group => <div key={group.label} data-id="element-475" data-mp="12ekoo27iyqsk">
            <p className="px-2 pb-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-muted-foreground" data-id="element-476" data-mp="12dssoqa0mr1r">
              {group.label}
            </p>
            <ul className="space-y-0.5" data-id="element-477" data-mp="sp13ur094mv2">
              {group.items.map(item => <li key={item.to} data-id="element-478" data-mp="smof9uzzne91">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => cn('flex items-center gap-2.5 rounded-sm px-2 py-2 text-[13px] transition-colors', isActive ? 'bg-uae-green text-white' : 'text-foreground hover:bg-muted')} data-id="element-479" data-mp="oo8vs1348o0d">
                    <item.icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-480" data-mp="30x7a8p3lsp7t" />
                    <span className="truncate" data-id="element-481" data-mp="35vh9basg89yp">{item.label}</span>
                  </NavLink>
                </li>)}
            </ul>
          </div>)}
      </div>

      <div className="mt-8 rounded-sm border border-border bg-muted/60 p-3" data-id="element-482" data-mp="2ryc57gcapl63">
        <p className="text-[11px] font-medium text-foreground" data-id="element-483" data-mp="2wwdoo2dmvmi3">Prototype environment</p>
        <p className="mt-1 text-[11px] leading-relaxed text-muted-foreground" data-id="element-484" data-mp="2hzculs7yzfgg">
          Records are seeded demonstration data. AI runs are simulated and every decision is
          recorded on the audit timeline.
        </p>
      </div>
    </nav>;
}